// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

import { THEME_NAME, THEME_MODE } from '../../../symbol';
/**
 * Design System theme object.
 *
 * Theme name: `canvas`
 *
 * Theme mode: `light`
 */
const theme = {
  borderRadius: {
    '0': '0px',
    '100': '3px',
    '200': '4px',
    '300': '8px',
    '400': '16px',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-core-component-default': '999999px',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-textarea-default': '16px',
    full: '999999px',
    'temp-do-not-use-300': '100px',
    'temp-future-300': '8px',
    'transitional-component': '0px',
    'transitional-container': '0px',
    'transitional-container-alt': '3px',
    'transitional-floating': '3px',
    'transitional-full-0': '0px',
    'transitional-full-3': '3px',
    'transitional-full-8': '8px'
  },
  borderWidth: {
    '0': '0px',
    '100': '1px',
    '200': '2px',
    '300': '4px',
    'transitional-1': '2px',
    'transitional-2': '0px'
  },
  boxShadow: {
    '100': '0px 1px 5px 0px rgba(44,61,79,0.12)',
    '200': '0px 1px 4px 0px rgba(66,91,117,0.06)',
    '300': '0px 3px 8px 0px rgba(0,0,0,0.1)',
    '400': '0px 1px 24px 0px rgba(0,0,0,0.08)'
  },
  color: {
    'border-accent-blue-default': '#00A4BD',
    'border-accent-green-default': '#00BDA5',
    'border-accent-light-orange-default': '#FF7A59',
    'border-accent-magenta-default': '#F2547D',
    'border-accent-orange-default': '#FF7A59',
    'border-accent-purple-default': '#6A78D1',
    'border-accent-red-default': '#F2545B',
    'border-accent-yellow-default': '#F5C26B',
    'border-alert-default': '#F2545B',
    'border-brand-default': '#FF7A59',
    'border-caution-default': '#F5C26B',
    'border-container-default': 'rgba(20,20,20,0)',
    'border-core-default': '#CBD6E2',
    'border-core-disabled': '#EAF0F6',
    'border-core-hover': '#7C98B6',
    'border-core-on-fill-default': '#FFFFFF',
    'border-core-pressed': '#EAF0F6',
    'border-core-subtle': '#DFE3EB',
    'border-core-subtle-hover': '#CBD6E2',
    'border-core-subtle-pressed': '#99ACC2',
    'border-info-default': '#00A4BD',
    'border-interactive-default': '#7FD1DE',
    'border-interactive-pressed': '#0091AE',
    'border-inverse-default': '#FFFFFF',
    'border-inverse-default-alt': '#FFFFFF',
    'border-inverse-disabled': 'rgba(20,20,20,0)',
    'border-inverse-disabled-alt': 'rgba(20,20,20,0)',
    'border-positive-default': '#00BDA5',
    'border-primary-default': 'rgba(20,20,20,0)',
    'border-primary-disabled': 'rgba(20,20,20,0)',
    'border-primary-on-fill': '#FFFFFF',
    'border-primary-on-fill-default': '#FFFFFF',
    'border-primary-subtle': '#DFE3EB',
    'border-primary-subtle-default': '#FFFFFF',
    'border-primary-subtle-hover': '#FFFFFF',
    'border-primary-subtle-pressed': '#7C98B6',
    'border-secondary-default': '#FF7A59',
    'border-secondary-disabled': 'rgba(0,0,0,0)',
    'border-surface-default': '#FFFFFF',
    'border-tertiary-default': '#CBD6E2',
    'border-tertiary-disabled': 'rgba(0,0,0,0)',
    'border-transitional-core-subtle': '#CBD6E2',
    'border-transitional-core-subtle-alt': 'rgba(20,20,20,0)',
    'border-transitional-interactive-subtle': '#7FD1DE',
    'border-transitional-tertiary-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-badge-default': 'linear-gradient(135deg, #FF3842 0%, #D20688 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-field-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-secondary-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-tertiary-default': '#8C8787',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-badge-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-component-disabled': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-feedback-active': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-feedback-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-feedback-hover': 'rgba(20,20,20,0.08)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-loading-dot-default': '#FF9FCC',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-primary-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-primary-disabled': '#EFEDEB',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-primary-hover': '#A5016A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-primary-pressed': '#800051',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-secondary-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-secondary-hover': '#FCEBF2',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-secondary-pressed': '#FBDBE9',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-shimmer-default': 'linear-gradient(135deg, #FBDDD2 0%, #FBDBE9 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-alt-default': 'linear-gradient(114deg, #FC0849 0%, #D20688 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-alt-disabled': '#FC0849',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-default': 'linear-gradient(135deg, #FF3842 0%, #D20688 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-hover': 'linear-gradient(135deg, #D9002B 0%, #A5016A 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-pressed': 'linear-gradient(135deg, #AC0020 0%, #800051 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-tertiary-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-tertiary-hover': 'rgba(20,20,20,0.08)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-tertiary-pressed': 'rgba(20,20,20,0.11)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-component-disabled': '#8C8787',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-feedback-active': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-feedback-default': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-field-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-field-disabled': '#8C8787',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-full-page-loader-default': 'linear-gradient(135deg, #FB31A7 0%, #FF4800 23%, #FBDDD2 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-icon-button-default': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-icon-button-hover': '#A5016A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-icon-button-pressed': '#800051',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-primary-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-primary-disabled': '#8C8787',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-secondary-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-special-btn-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-tertiary-default': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-transparent-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-badge-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-component-disabled': '#8C8787',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-field-default': '#8C8787',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-field-disabled': '#8C8787',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-field-input': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-primary-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-primary-disabled': '#8C8787',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-secondary-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-special-btn-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-tertiary-default': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-transparent-default': '#D20688',
    'do-not-use-alert-danger': '#f04b51',
    'do-not-use-alert-success': '#5967bc',
    'do-not-use-alert-warning': '#fdf3e1',
    'do-not-use-battleship': '#cbd6e2',
    'do-not-use-button-danger-hover-fill': '#ff5962',
    'do-not-use-button-disabled-text': '#b0c1d4',
    'do-not-use-button-primary-hover-fill': '#ff8f73',
    'do-not-use-button-secondary-active-fill': '#ffebe6',
    'do-not-use-button-secondary-hover-fill': '#fff8f6',
    'do-not-use-button-secondary-text': '#ff7a53',
    'do-not-use-button-tertiary-light-hover-fill': '#e5eaf0',
    'do-not-use-button-tertiary-light-text': '#506e91',
    'do-not-use-calypso': '#00a4bd',
    'do-not-use-calypso-dark': '#0091ae',
    'do-not-use-calypso-light': '#e5f5f8',
    'do-not-use-calypso-medium': '#7fd1de',
    'do-not-use-candy-apple': '#f2545b',
    'do-not-use-candy-apple-dark': '#d94c53',
    'do-not-use-candy-apple-light': '#fdedee',
    'do-not-use-candy-apple-medium': '#f8a9ad',
    'do-not-use-chart-aqua': '#51d3d9',
    'do-not-use-chart-blue': '#81c1fd',
    'do-not-use-chart-dark-purple': '#9784c2',
    'do-not-use-chart-green': '#a2d28f',
    'do-not-use-chart-orange': '#fea58e',
    'do-not-use-chart-purple': '#bda9ea',
    'do-not-use-chart-red': '#ea90b1',
    'do-not-use-chart-yellow': '#f5c78e',
    'do-not-use-cirrus': '#f2f5f8',
    'do-not-use-eerie': '#7c98b6',
    'do-not-use-facebook': '#3b5998',
    'do-not-use-flat-earth': '#253342',
    'do-not-use-flint': '#99acc2',
    'do-not-use-focus-ring-base': '#00d0e4',
    'do-not-use-google': '#dd4b39',
    'do-not-use-great-white': '#dfe3eb',
    'do-not-use-gypsum': '#f5f8fa',
    'do-not-use-heffalump': '#425b76',
    'do-not-use-instagram': '#c13584',
    'do-not-use-koala': '#eaf0f6',
    'do-not-use-link-hover': '#007a8c',
    'do-not-use-linkedin': '#0077b5',
    'do-not-use-lorax': '#ff7a59',
    'do-not-use-lorax-dark': '#e66e50',
    'do-not-use-lorax-light': '#fff1ee',
    'do-not-use-lorax-medium': '#ffbcac',
    'do-not-use-marigold': '#f5c26b',
    'do-not-use-marigold-dark': '#dbae60',
    'do-not-use-marigold-light': '#fef8f0',
    'do-not-use-marigold-medium': '#fae0b5',
    'do-not-use-monolith': '#000000',
    'do-not-use-norman': '#f2547d',
    'do-not-use-norman-dark': '#d94c71',
    'do-not-use-norman-light': '#fdedf2',
    'do-not-use-norman-medium': '#f9aabe',
    'do-not-use-obsidian': '#33475b',
    'do-not-use-olaf': '#ffffff',
    'do-not-use-oz': '#00bda5',
    'do-not-use-oz-dark': '#00a38d',
    'do-not-use-oz-light': '#e5f8f6',
    'do-not-use-oz-medium': '#7fded2',
    'do-not-use-pantera': '#2d3e50',
    'do-not-use-pinterest': '#bd081c',
    'do-not-use-rss': '#f26522',
    'do-not-use-slinky': '#516f90',
    'do-not-use-sorbet': '#ff8f59',
    'do-not-use-sorbet-dark': '#e68250',
    'do-not-use-sorbet-light': '#fff3ee',
    'do-not-use-sorbet-medium': '#ffc7ac',
    'do-not-use-thunderdome': '#6a78d1',
    'do-not-use-thunderdome-dark': '#5e6ab8',
    'do-not-use-thunderdome-light': '#f0f1fa',
    'do-not-use-thunderdome-medium': '#b4bbe8',
    'do-not-use-transparent': 'rgba(0, 0, 0, 0)',
    'do-not-use-transparent-dark': 'rgba(0, 0, 0, 0)',
    'do-not-use-transparent-light': 'rgba(255, 255, 255, 0)',
    'do-not-use-twitter': '#55acee',
    'do-not-use-x': '#000000',
    'do-not-use-xing': '#026466',
    'do-not-use-youtube': '#ff0000',
    'fill-accent-blue-default': '#00A4BD',
    'fill-accent-blue-hover': '#7FD1DE',
    'fill-accent-blue-pressed': '#0091AE',
    'fill-accent-blue-subtle': '#E5F5F8',
    'fill-accent-blue-subtle-alt': '#E5F5F8',
    'fill-accent-green-default': '#00BDA5',
    'fill-accent-green-hover': '#7FDED2',
    'fill-accent-green-pressed': '#00A38D',
    'fill-accent-green-subtle': '#E5F8F6',
    'fill-accent-green-subtle-alt': '#E5F8F6',
    'fill-accent-light-orange-default': '#FF8F59',
    'fill-accent-light-orange-hover': '#FFC7AC',
    'fill-accent-light-orange-pressed': '#E68250',
    'fill-accent-light-orange-subtle': '#FFF3EE',
    'fill-accent-light-orange-subtle-alt': '#FFF3EE',
    'fill-accent-magenta-default': '#F2547D',
    'fill-accent-magenta-hover': '#F9AABE',
    'fill-accent-magenta-pressed': '#D94C71',
    'fill-accent-magenta-subtle': '#FDEDF2',
    'fill-accent-magenta-subtle-alt': '#FDEDF2',
    'fill-accent-neutral-default': '#425B76',
    'fill-accent-neutral-hover': '#516F90',
    'fill-accent-neutral-pressed': '#33475B',
    'fill-accent-neutral-subtle': '#425B76',
    'fill-accent-neutral-subtle-alt': '#EAF0F6',
    'fill-accent-orange-default': '#FF7A59',
    'fill-accent-orange-hover': '#FFBCAC',
    'fill-accent-orange-pressed': '#E66E50',
    'fill-accent-orange-subtle': '#FFF1EE',
    'fill-accent-orange-subtle-alt': '#FFF1EE',
    'fill-accent-purple-default': '#6A78D1',
    'fill-accent-purple-hover': '#B4BBE8',
    'fill-accent-purple-pressed': '#5E6AB8',
    'fill-accent-purple-subtle': '#F0F1FA',
    'fill-accent-purple-subtle-alt': '#F0F1FA',
    'fill-accent-red-default': '#F2545B',
    'fill-accent-red-hover': '#F8A9AD',
    'fill-accent-red-pressed': '#D94C53',
    'fill-accent-red-subtle': '#FDEDEE',
    'fill-accent-red-subtle-alt': '#FDEDEE',
    'fill-accent-teal-default': '#00A4BD',
    'fill-accent-teal-hover': '#7FD1DE',
    'fill-accent-teal-pressed': '#0091AE',
    'fill-accent-teal-subtle': '#E5F5F8',
    'fill-accent-teal-subtle-alt': '#E5F5F8',
    'fill-accent-yellow-default': '#F5C26B',
    'fill-accent-yellow-hover': '#FAE0B5',
    'fill-accent-yellow-pressed': '#DBAE60',
    'fill-accent-yellow-subtle': '#FEF8F0',
    'fill-accent-yellow-subtle-alt': '#FEF8F0',
    'fill-alert-default': '#F2545B',
    'fill-alert-hover': '#FF5962',
    'fill-alert-pressed': '#D94C53',
    'fill-alert-subtle': '#FDEDEE',
    'fill-brand-default': '#FF7A59',
    'fill-brand-hover': '#FF8F73',
    'fill-brand-pressed': '#E66E50',
    'fill-brand-subtle': '#FFF1EE',
    'fill-caution-alt': '#FCCB57',
    'fill-caution-default': '#F5C26B',
    'fill-caution-hover': '#FAE0B5',
    'fill-caution-pressed': '#DBAE60',
    'fill-caution-subtle': '#FEF8F0',
    'fill-field-default': '#F5F8FA',
    'fill-field-default-alt': '#FFFFFF',
    'fill-field-disabled': '#EAF0F6',
    'fill-field-hover': '#E5F5F8',
    'fill-field-pressed': '#EAF0F6',
    'fill-info-default': '#00A4BD',
    'fill-info-hover': '#7FD1DE',
    'fill-info-pressed': '#0091AE',
    'fill-info-subtle': '#E5F5F8',
    'fill-inverse-danger': '#F2545B',
    'fill-inverse-default': 'rgba(20,20,20,0)',
    'fill-inverse-default-alt': '#FFFFFF',
    'fill-inverse-default-transparent': 'rgba(20,20,20,0)',
    'fill-inverse-disabled': '#EAF0F6',
    'fill-inverse-disabled-alt': '#EAF0F6',
    'fill-inverse-disabled-transparent': '#EAF0F6',
    'fill-inverse-hover': 'rgba(255,255,255,0.08)',
    'fill-inverse-hover-alt': '#FFFFFF',
    'fill-inverse-hover-transparent': 'rgba(255,255,255,0.08)',
    'fill-inverse-pressed': 'rgba(255,255,255,0.11)',
    'fill-inverse-pressed-alt': '#FFFFFF',
    'fill-inverse-pressed-transparent': 'rgba(255,255,255,0.11)',
    'fill-inverse-primary': '#FF7A59',
    'fill-inverse-subtle': '#425B76',
    'fill-positive-alt': '#38D84C',
    'fill-positive-default': '#00BDA5',
    'fill-positive-hover': '#7FDED2',
    'fill-positive-pressed': '#00A38D',
    'fill-positive-subtle': '#E5F8F6',
    'fill-primary-default': '#FF7A59',
    'fill-primary-disabled': '#EAF0F6',
    'fill-primary-hover': '#FF8F73',
    'fill-primary-pressed': '#E66E50',
    'fill-primary-subtle': '#FFF1EE',
    'fill-secondary-default': '#FFFFFF',
    'fill-secondary-disabled': '#EAF0F6',
    'fill-secondary-hover': '#FFF1EE',
    'fill-secondary-pressed': '#FFF1EE',
    'fill-secondary-subtle': '#E5F5F8',
    'fill-surface-default': '#FFFFFF',
    'fill-surface-default-hover': '#FFFFFF',
    'fill-surface-default-pressed': '#FFFFFF',
    'fill-surface-overlay': '#333333',
    'fill-surface-raised': '#F5F8FA',
    'fill-surface-recessed': '#F5F8FA',
    'fill-surface-recessed-hover': '#FFFFFF',
    'fill-surface-recessed-pressed': '#FFFFFF',
    'fill-tertiary-alt': '#CBD6E2',
    'fill-tertiary-default': '#EAF0F6',
    'fill-tertiary-disabled': '#EAF0F6',
    'fill-tertiary-hover': '#F5F8FA',
    'fill-tertiary-pressed': '#CBD6E2',
    'fill-tertiary-subtle': '#DFE3EB',
    'fill-transitional-alert': '#F2547D',
    'fill-transitional-banner-gradient-color-1': '#FF7A59',
    'fill-transitional-banner-gradient-color-2': '#F2547D',
    'fill-transitional-danger-pattern-color-1': '#FF5962',
    'fill-transitional-danger-pattern-color-2': '#F2545B',
    'fill-transitional-field-hover': '#7FD1DE',
    'fill-transitional-modal-gradient-color-1': '#00A4BD',
    'fill-transitional-modal-gradient-color-2': '#00BDA5',
    'fill-transitional-popover': '#6A78D1',
    'fill-transitional-progress-success-gradient-color-1': '#00BDA5',
    'fill-transitional-progress-success-gradient-color-2': '#00A4BD',
    'fill-transitional-progress-warning-danger-gradient-color-1': '#FF8F59',
    'fill-transitional-progress-warning-danger-gradient-color-2': '#F5C26B',
    'fill-transitional-scroll-default-gradient-color-1': '#F5F8FA',
    'fill-transitional-scroll-default-gradient-color-2': 'rgba(255,255,255,0)',
    'fill-transitional-scroll-fadeout-gradient-color-1': '#FFFFFF',
    'fill-transitional-scroll-fadeout-gradient-color-2': 'rgba(255,255,255,0)',
    'fill-transitional-shadow': 'rgba(255,143,89,0.4)',
    'fill-transitional-table-default': '#F5F8FA',
    'fill-transitional-tabs-default': '#F5F8FA',
    'fill-transitional-tabs-pressed': '#F5F8FA',
    'fill-transitional-tertiary-default': '#425B76',
    'fill-transitional-tertiary-hover': '#516F90',
    'fill-transitional-tertiary-pressed': '#33475B',
    'fill-transitional-upgrade-modal-gradient-color-1': '#FF7A59',
    'fill-transparent-default': 'rgba(0,0,0,0)',
    'fill-transparent-disabled': '#EAF0F6',
    'fill-transparent-hover': '#F5F8FA',
    'fill-transparent-pressed': '#F5F8FA',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-dark': '#425B76',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-default': '#516F90',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-search-btn-border-default': '#516F90',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-search-btn-border-hover': '#425B76',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-search-field-border-default': 'rgba(0,0,0,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-subtle': '#7C98B6',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-editortitle-hover': '#516F90',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-logo-default': '#FF7A59',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-nav-item-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-nav-item-hover': '#425B76',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-nav-item-selected': '#516F90',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-search-default': 'rgba(0,0,0,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-search-hover': '#425B76',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-sub-nav-item-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-sub-nav-item-hover': '#516F90',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-sub-nav-item-selected': '#516F90',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-surface-default': '#2D3E50',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-surface-panel-default': '#425B76',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-bookmark-default': 'rgba(0,0,0,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-bookmark-hover': '#DFE3EB',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-bookmark-selected': '#7C98B6',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-copilot-default': '#FBDBE9',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-nav-item-default': '#DFE3EB',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-nav-item-hover': '#F5F8FA',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-nav-item-selected': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-nav-item-subtle': '#516F90',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-copilot-default': '#FBDBE9',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-copilot-hover': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-default': '#DFE3EB',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-hover': '#F5F8FA',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-selected': '#FFFFFF',
    'icon-accent-blue-default': '#8CC4F4',
    'icon-accent-blue-on-fill-default': '#FFFFFF',
    'icon-accent-blue-on-fill-subtle': '#8CC4F4',
    'icon-accent-green-default': '#38D84C',
    'icon-accent-green-on-fill-default': '#FFFFFF',
    'icon-accent-green-on-fill-subtle': '#38D84C',
    'icon-accent-magenta-default': '#FF9FCC',
    'icon-accent-magenta-on-fill-default': '#FFFFFF',
    'icon-accent-magenta-on-fill-subtle': '#FF9FCC',
    'icon-accent-orange-default': '#FFA581',
    'icon-accent-orange-on-fill-default': '#411204',
    'icon-accent-orange-on-fill-subtle': '#FFA581',
    'icon-accent-purple-default': '#C4B4F7',
    'icon-accent-purple-on-fill-default': '#FFFFFF',
    'icon-accent-purple-on-fill-subtle': '#C4B4F7',
    'icon-accent-red-default': '#FF3842',
    'icon-accent-red-on-fill-default': '#FFFFFF',
    'icon-accent-red-on-fill-subtle': '#FF7B70',
    'icon-accent-teal-default': '#48D1CF',
    'icon-accent-teal-on-fill-default': '#FFFFFF',
    'icon-accent-teal-on-fill-subtle': '#48D1CF',
    'icon-accent-yellow-default': '#EEB117',
    'icon-accent-yellow-on-fill-default': '#1F1F1F',
    'icon-accent-yellow-on-fill-subtle': '#EEB117',
    'icon-alert-default': '#F2545B',
    'icon-alert-hover': '#F8A9AD',
    'icon-alert-on-fill-default': '#FFFFFF',
    'icon-alert-on-fill-subtle': '#FF7B70',
    'icon-alert-pressed': '#D94C53',
    'icon-brand-default': '#FFA581',
    'icon-brand-on-fill-default': '#411204',
    'icon-brand-on-fill-subtle': '#FFA581',
    'icon-caution-default': '#EEB117',
    'icon-caution-on-fill-alt': '#331E06',
    'icon-caution-on-fill-default': '#1F1F1F',
    'icon-caution-on-fill-subtle': '#EEB117',
    'icon-core-default': '#33475B',
    'icon-core-disabled': '#99ACC2',
    'icon-core-on-fill-default': '#FFFFFF',
    'icon-core-subtle': '#7C98B6',
    'icon-info-default': '#8CC4F4',
    'icon-info-on-fill-default': '#FFFFFF',
    'icon-info-on-fill-subtle': '#8CC4F4',
    'icon-interactive-default': '#0091AE',
    'icon-interactive-disabled': '#99ACC2',
    'icon-interactive-hover': '#007A8C',
    'icon-interactive-on-fill-default': '#FFFFFF',
    'icon-interactive-on-fill-hover': '#FFFFFF',
    'icon-interactive-on-fill-pressed': '#FFFFFF',
    'icon-interactive-on-fill-subtle': '#C4B4F7',
    'icon-interactive-pressed': '#7FD1DE',
    'icon-inverse-default': '#FFFFFF',
    'icon-inverse-default-alt': '#33475B',
    'icon-inverse-disabled': '#99ACC2',
    'icon-inverse-disabled-alt': '#99ACC2',
    'icon-inverse-hover': '#7FD1DE',
    'icon-inverse-pressed': '#FFFFFF',
    'icon-positive-default': '#38D84C',
    'icon-positive-on-fill-alt': '#042905',
    'icon-positive-on-fill-default': '#FFFFFF',
    'icon-positive-on-fill-subtle': '#38D84C',
    'icon-primary-default': '#FFFFFF',
    'icon-primary-disabled': '#99ACC2',
    'icon-primary-hover': '#FFFFFF',
    'icon-primary-on-fill-default': '#FFFFFF',
    'icon-primary-on-fill-subtle': '#B6B1AF',
    'icon-primary-pressed': '#FFFFFF',
    'icon-secondary-default': '#FF7A59',
    'icon-secondary-disabled': '#99ACC2',
    'icon-secondary-subtle': '#FFFFFF',
    'icon-tertiary-default': '#516F90',
    'icon-tertiary-disabled': '#99ACC2',
    'specialty-notification': '#D9002B',
    'specialty-scrim': 'rgba(45,62,80,0.8)',
    'specialty-scrim-alt': 'rgba(255,255,255,0.8)',
    'temp-do-not-use-border-primary-default': '#CBD6E2',
    'temp-do-not-use-border-primary-disabled': '#EAF0F6',
    'temp-do-not-use-fill-accent-teal-default': '#007C7D',
    'temp-do-not-use-fill-accent-teal-hover': '#006162',
    'temp-do-not-use-fill-accent-teal-pressed': '#00494B',
    'temp-do-not-use-fill-accent-teal-subtle': '#051919',
    'temp-do-not-use-fill-field-hover': '#F5F8FA',
    'temp-do-not-use-fill-field-pressed': '#F5F8FA',
    'temp-do-not-use-fill-secondary-default': '#00A4BD',
    'temp-do-not-use-fill-secondary-hover': '#7FD1DE',
    'temp-do-not-use-fill-secondary-pressed': '#0091AE',
    'temp-do-not-use-fill-surface-default-hover': '#242424',
    'temp-do-not-use-fill-surface-default-pressed': '#292929',
    'temp-do-not-use-fill-surface-recessed': '#253342',
    'temp-do-not-use-icon-primary-default': '#7C98B6',
    'temp-do-not-use-icon-primary-hover': '#7C98B6',
    'temp-do-not-use-icon-primary-pressed': '#33475B',
    'temp-do-not-use-specialty-scrim': '#000000',
    'temp-do-not-use-text-primary-default': '#33475B',
    'temp-do-not-use-text-primary-subtle': '#516F90',
    'temp-future-border-primary-default': 'rgba(20,20,20,0)',
    'temp-future-border-primary-disabled': 'rgba(20,20,20,0)',
    'temp-future-fill-accent-teal-default': '#00A4BD',
    'temp-future-fill-accent-teal-hover': '#7FD1DE',
    'temp-future-fill-accent-teal-pressed': '#0091AE',
    'temp-future-fill-accent-teal-subtle': '#E5F5F8',
    'temp-future-fill-field-hover': '#E5F5F8',
    'temp-future-fill-field-pressed': '#EAF0F6',
    'temp-future-fill-secondary-default': '#FFFFFF',
    'temp-future-fill-secondary-hover': '#FFF1EE',
    'temp-future-fill-secondary-pressed': '#FFF1EE',
    'temp-future-fill-surface-default-hover': '#FFFFFF',
    'temp-future-fill-surface-default-pressed': '#FFFFFF',
    'temp-future-fill-surface-recessed': '#F5F8FA',
    'temp-future-icon-primary-default': '#FFFFFF',
    'temp-future-icon-primary-hover': '#FFFFFF',
    'temp-future-icon-primary-pressed': '#FFFFFF',
    'temp-future-specialty-scrim': 'rgba(45,62,80,0.8)',
    'temp-future-text-primary-default': '#FFFFFF',
    'temp-future-text-primary-subtle': '#FFFFFF',
    'text-accent-blue-default': '#5CAAFF',
    'text-accent-blue-on-fill-default': '#FFFFFF',
    'text-accent-blue-on-fill-subtle': '#8CC4F4',
    'text-accent-green-default': '#27BD3E',
    'text-accent-green-on-fill-default': '#FFFFFF',
    'text-accent-green-on-fill-subtle': '#38D84C',
    'text-accent-magenta-default': '#FF72BA',
    'text-accent-magenta-on-fill-default': '#FFFFFF',
    'text-accent-magenta-on-fill-subtle': '#FF9FCC',
    'text-accent-purple-default': '#AC98F8',
    'text-accent-purple-on-fill-default': '#FFFFFF',
    'text-accent-purple-on-fill-subtle': '#C4B4F7',
    'text-accent-red-default': '#FF7B70',
    'text-accent-red-on-fill-default': '#FFFFFF',
    'text-accent-red-on-fill-subtle': '#FFA499',
    'text-accent-teal-default': '#21B7B7',
    'text-accent-teal-on-fill-default': '#FFFFFF',
    'text-accent-teal-on-fill-subtle': '#48D1CF',
    'text-accent-yellow-default': '#D39913',
    'text-accent-yellow-on-fill-default': '#FFFFFF',
    'text-accent-yellow-on-fill-subtle': '#EEB117',
    'text-alert-default': '#F2545B',
    'text-alert-hover': '#F8A9AD',
    'text-alert-on-fill': '#FFFFFF',
    'text-alert-on-fill-default': '#FFFFFF',
    'text-alert-on-fill-subtle': '#FF7B70',
    'text-alert-pressed': '#D94C53',
    'text-brand-default': '#FF7A59',
    'text-brand-on-fill-default': '#FFFFFF',
    'text-brand-on-fill-subtle': '#FFA581',
    'text-caution-default': '#D39913',
    'text-caution-on-fill-alt': '#331E06',
    'text-caution-on-fill-default': '#1F1F1F',
    'text-caution-on-fill-subtle': '#EEB117',
    'text-core-default': '#33475B',
    'text-core-disabled': '#99ACC2',
    'text-core-on-fill-default': '#FFFFFF',
    'text-core-subtle': '#516F90',
    'text-info-default': '#5CAAFF',
    'text-info-on-fill-default': '#FFFFFF',
    'text-info-on-fill-subtle': '#8CC4F4',
    'text-interactive-default': '#0091AE',
    'text-interactive-default-disabled': '#99ACC2',
    'text-interactive-default-hover': '#007A8C',
    'text-interactive-default-pressed': '#7FD1DE',
    'text-interactive-on-fill': '#FFFFFF',
    'text-interactive-on-fill-default': '#FFFFFF',
    'text-interactive-on-fill-hover': '#FFFFFF',
    'text-interactive-on-fill-pressed': '#FFFFFF',
    'text-interactive-on-fill-subtle': '#C4B4F7',
    'text-inverse-default': '#FFFFFF',
    'text-inverse-default-alt': '#33475B',
    'text-inverse-disabled': '#99ACC2',
    'text-inverse-disabled-alt': '#99ACC2',
    'text-inverse-hover': '#7FD1DE',
    'text-inverse-pressed': '#FFFFFF',
    'text-positive-default': '#00BDA5',
    'text-positive-on-fill-alt': '#042905',
    'text-positive-on-fill-default': '#FFFFFF',
    'text-positive-on-fill-subtle': '#38D84C',
    'text-primary-default': '#FFFFFF',
    'text-primary-disabled': '#99ACC2',
    'text-primary-on-fill-default': '#FFFFFF',
    'text-primary-on-fill-subtle': '#B6B1AF',
    'text-primary-subtle': '#FFFFFF',
    'text-secondary-default': '#FF7A59',
    'text-secondary-disabled': '#99ACC2',
    'text-tertiary-default': '#516F90',
    'text-tertiary-disabled': '#99ACC2'
  },
  space: {
    '0': '0px',
    '25': '1px',
    '50': '2px',
    '100': '4px',
    '200': '8px',
    '250': '10px',
    '300': '12px',
    '400': '16px',
    '500': '20px',
    '600': '24px',
    '700': '28px',
    '800': '32px',
    '900': '36px',
    '1000': '40px',
    '1100': '48px',
    '1200': '56px',
    '1300': '60px',
    '1400': '64px',
    '1500': '96px',
    '1600': '144px',
    '1700': '192px'
  },
  typography: {
    'body-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'body-125': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'body-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'body-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '18px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'body-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '20px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '28px'
    },
    'body-500': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '22px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '28px'
    },
    'body-600': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '26px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '32px'
    },
    'body-700': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '28px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '36px'
    },
    'code-100': {
      fontFamily: 'Source Code Pro, Consolas, Monaco, Courier New, monospace',
      fontSize: '14px',
      fontWeight: '500',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'detail-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '14px'
    },
    'detail-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '18px'
    },
    'display-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '56px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '72px'
    },
    'display-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '66px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '76px'
    },
    'display-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '76px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '88px'
    },
    'display-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '84px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '96px'
    },
    'display-500': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '94px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '100px'
    },
    'heading-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '20px'
    },
    'heading-1000': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '55px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '67px'
    },
    'heading-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '18px',
      fontWeight: '500',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'heading-25': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '18px'
    },
    'heading-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '20px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'heading-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '22px',
      fontWeight: '500',
      letterSpacing: '0px',
      lineHeight: '27px'
    },
    'heading-50': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '18px'
    },
    'heading-500': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '24px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '29px'
    },
    'heading-600': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '32px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '39px'
    },
    'heading-700': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '36px',
      fontWeight: '500',
      letterSpacing: '-0.16px',
      lineHeight: '44px'
    },
    'heading-800': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '42px',
      fontWeight: '500',
      letterSpacing: '-0.16px',
      lineHeight: '52px'
    },
    'heading-900': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '46px',
      fontWeight: '500',
      letterSpacing: '-0.16px',
      lineHeight: '56px'
    },
    'link-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'link-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'link-25': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '18px'
    }
  }
};
Object.assign(theme, {
  [THEME_NAME]: 'canvas',
  [THEME_MODE]: 'light'
});
export default theme;